<div *ngIf="environment.env==='test'" style="padding: 10px;">
  <mat-icon aria-hidden="true" color="primary">warning</mat-icon>
  <strong style="font-size: 1.2em;">
    <mark>Cet espace est l'application de TEST afin de prendre en main l'outil ou de détecter des anomalies,
      aucune donnée / information ne sera conservée et ne représente en aucun cas de réelles informations à exploiter, elles ne seront pas reprises en production</mark>
    <br/>
    <mark>Ne pas partager le lien de l'environnement / application test</mark>
  </strong>
  <mat-icon aria-hidden="true" color="primary">warning</mat-icon>
</div>
